import Vue from 'vue'
import App from './App.vue'
import 'promise-polyfill/src/polyfill';
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios';


import VueAxios from 'vue-axios'
Vue.prototype.$axios = axios
Vue.use(VueAxios, axios)

// import Datetime from 'vue-datetime'
// // You need a specific loader for CSS files
// import 'vue-datetime/dist/vue-datetime.css'
 
// Vue.use(Datetime)
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
   
// You need a specific loader for CSS files
//import 'vue-datetime/dist/vue-datetime.css'
 
Vue.use(datePicker)

Vue.component('date-picker', datePicker);
library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

window.axios = require('axios');
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2);
Vue.use(axios);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
